import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {Container} from './styles';
import {FiChevronsLeft, FiChevronsRight, FiChevronLeft, FiChevronRight,} from 'react-icons/fi';
import {IoMdClose} from 'react-icons/io';
import Calendar from 'react-calendar';
import '../../../css/Calendar.css';
import moment from 'moment';
import api from '../../../services/api';
import Calendario from '../../../assets/emojis/calendario/calendario@3x.png'

export default class DiasModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            date: [],
            text: '',
            anual: false,
            inputClass: 'div-input',
            redirect: null
        }
    }

    // handleChange(check) {
    //     this.setState({
    //         anual: !check
    //     })
    // }

    async salvar() {
        try {
            switch (this.state.date.length) {
                case 1:
                    try {
                        const data = (moment(this.state.date[0]).format()).substr(0, 10);
                        api.post('api/restauranteconfigs/criaferiado', {
                            data: data,
                            descricao: this.state.text,
                            anual: this.state.anual
                        }, {
                            headers: {
                                Authorization: `Bearer ${this.props.token}`
                            }
                        }).then(async res => {
                            await this.props.reload();
                            this.props.closeModal();
                            this.props.success();
                        }).catch(async e => {
                            this.props.error();
                            if (e.response.status === 401) {
                                try {
                                    await localStorage.removeItem('@username');
                                    await localStorage.removeItem('@jwt');
                                    await localStorage.removeItem('@user');
                                    await localStorage.removeItem('@rest');
                                    await localStorage.removeItem('@internal');
                                    await localStorage.removeItem('@uf');
                                    await localStorage.removeItem('@suser');
                                    this.setState({
                                        redirect: true
                                    })
                                } catch (e) {
                                    console.log(e.data);
                                }
                            }
                        });
                    } catch (e) {
                        console.log(e.data);
                    }
                    break;
                case 2:
                    try {
                        const data1 = (moment(this.state.date[0]).format()).substr(0, 10);
                        const data2 = (moment(this.state.date[1]).format()).substr(0, 10);
                        api.post('api/restauranteconfigs/criarange', {
                            primeiroDia: data1,
                            ultimoDia: data2,
                            descricao: this.state.text,
                            anual: this.state.anual
                        }, {
                            headers: {
                                Authorization: `Bearer ${this.props.token}`
                            }
                        }).then(async res => {
                            await this.props.reload();
                            this.props.closeModal();
                        }).catch(async e => {
                            if (e.response.status === 401) {
                                try {
                                    await localStorage.removeItem('@username');
                                    await localStorage.removeItem('@jwt');
                                    await localStorage.removeItem('@user');
                                    await localStorage.removeItem('@rest');
                                    await localStorage.removeItem('@internal');
                                    await localStorage.removeItem('@uf');
                                    await localStorage.removeItem('@suser');
                                    this.setState({
                                        redirect: true
                                    })
                                } catch (e) {
                                    console.log(e.data);
                                }
                            }
                        });
                    } catch (e) {
                        console.log(e.data);
                    }
                    break;
                default:
                    break;
            }
        } catch (error) {
            console.log(error.data);
        }
    }
//asdasds
    render() {
        if(this.state.redirect) {
            return <Redirect to="/login"/>
        }
        return (
            <Container>
                <div className="close">
                    <button 
                        onClick={() => this.props.closeModal()}>
                        <IoMdClose color="#fff" className="i-close" />
                    </button>
                </div>
                <div className="header">
                    <img alt="" className="emoji" src={Calendario} />
                    <h1>Adicione os dias que o seu restaurante não vai abrir.</h1>
                </div>
                <div className="calendario">
                    <Calendar
                        tileClassName="tile-calendar"
                        minDetail="month"
                        selectRange
                        allowPartialRange
                        returnValue="range"
                        nextLabel={<FiChevronRight size={24} />}
                        next2Label={<FiChevronsRight size={24} />}
                        prevLabel={<FiChevronLeft size={24} />}
                        prev2Label={<FiChevronsLeft size={24} />}
                        minDate={new Date()}
                        onChange={(value) => this.setState({
                            date: value
                        })
                        }
                    />
                </div>

                {/* <div 
                    className="cartao">
                    <label className="main">
                        <input
                            type="checkbox"
                            defaultChecked={this.state.anual}
                            onChange={() => 
                                this.handleChange(this.state.anual)
                            }
                        />
                        <span className="check"></span>
                        <span className="label-resto">Repetir esta data anualmente</span>    
                    </label>
                </div> */}

                <div className={this.state.inputClass}>
                            <input
                                ref={elem => (this.textInput = elem)}
                                value={this.state.text}
                                onFocus={() => {
                                    this.setState({
                                        inputClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        inputClass: 'div-input'
                                    })
                                }}
                                onChange={e => this.setState({
                                    text: e.target.value
                                })}
                                name="textName"
                                type="text"
                                // placeholder="Digite o seu usuário"
                                required 
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Digite um nome ou descrição</span>
                            </label>
                    </div>

                <div className="botao">
                    <button 
                        onClick={() => this.salvar()}
                        className="salvar">Salvar alterações</button>
                </div>
            </Container>
        )
    }
}